module.exports = __webpack_public_path__ + "img/open-envelope-idea.5eb74db3.png";